import { render, staticRenderFns } from "./deletePrinterRuleFee.vue?vue&type=template&id=a119b094&scoped=true"
import script from "./deletePrinterRuleFee.vue?vue&type=script&lang=js"
export * from "./deletePrinterRuleFee.vue?vue&type=script&lang=js"
import style0 from "./deletePrinterRuleFee.vue?vue&type=style&index=0&id=a119b094&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a119b094",
  null
  
)

export default component.exports